
    var riot = require('riot')
    riot.tag2('gb-badge', '<span><yield></yield></span>', 'gb-badge.gb-stylish > span,[data-is="gb-badge"].gb-stylish > span{ display: inline-block; min-width: 10px; max-height: 20px; padding: 4px 7px; border-radius: 10px; font-size: 12px; font-weight: bold; line-height: 1; color: #fff; background-color: #ccc; text-align: center; white-space: nowrap; vertical-align: middle; }', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/badge/gb-badge.tag.html